import { NewPosicionPrecio, TradeDetailsResponse } from "../../api";

export enum TradesActionTypes {
  STORE_ACTIVE_TRADE = 'STORE_ACTIVE_TRADE',
  STORE_ACTIVE_POSITION = 'STORE_ACTIVE_POSITION'
}

export interface StoreActiveTradeAction {
  type: TradesActionTypes;
  payload: TradeDetailsResponse | null;
}

export interface StoreActivePositionAction {
  type: TradesActionTypes;
  payload: NewPosicionPrecio | null;
}

export const storeActiveTradeAction = (trade: TradeDetailsResponse | null): StoreActiveTradeAction => {
  return { type: TradesActionTypes.STORE_ACTIVE_TRADE, payload: trade };
};

export const storeActivePositionAction = (position: NewPosicionPrecio | null): StoreActivePositionAction => {
  return { type: TradesActionTypes.STORE_ACTIVE_POSITION, payload: position };
};